<app-header></app-header>
<div class="" style="min-height: 77vh">
  <app-dashboard></app-dashboard>
</div>

<div class="footer">
  <app-footer></app-footer>
</div>
